module.exports = __webpack_public_path__ + "static/foto-servicios-big-fc791795d9c971ef7b2d04b57e8905bb.webp";